import React from 'react';
import { Panel } from '../../../../../components/containers/Panel';
import classes from './MetricCounter.module.scss';
import { format } from 'date-fns';
import { PanelHeader } from '../../../../../components/containers/Panel/PanelHeader.view';
import { Loader } from '../../../../../components/containers/Loader';

type MetricCounterProps = {
  title: string;
  metricValue: number | null | undefined;
  dateStart?: Date;
  dateEnd: Date;
  tooltipText: string;
  loading: boolean;
};
export const MetricCounterView = ({
  title,
  metricValue,
  dateEnd,
  tooltipText,
  loading,
  dateStart
}: MetricCounterProps) => {
  const formatString = 'dd MMM';
  const dateString = dateStart
    ? `${format(dateStart, formatString)} - ${format(dateEnd, formatString)}`
    : format(dateEnd, formatString);
  return (
    <Panel customClass={classes.Panel}>
      <PanelHeader title={title} tooltip={tooltipText} />
      <div className={classes.ValueContainer}>
        {loading && <Loader size={'small'} variation={'dark'} />}
        {!loading && (
          <>
            {typeof metricValue !== 'number' ? (
              <h4 className={classes.NoData}>No Data</h4>
            ) : (
              <h2>{metricValue.toLocaleString('en-US')}</h2>
            )}
          </>
        )}
      </div>
      <span>{dateString}</span>
    </Panel>
  );
};
